<div class="h-full flex flex-col">
  <xemex-tab-bar
    [tabs]="tabs()"
    [defaultTab]="defaultTab()"
    [mode]="mode()"
    (tabChange)="onTabBarChange($event)"
  ></xemex-tab-bar>
  <div class="flex-1 overflow-auto">
    <ng-content></ng-content>
  </div>
</div>
